let offerCode = {
    code: 'ABCD',
    disCount: 20,
}

let sendPrice = 0;

export default offerCode

export {sendPrice}